<template>
  <div class="product-item product-itinerary-jd">
    <div class="product-head clearfix">
      <img class="f-left"
        :src="productBase.icon"
        alt
      />
      <div class="f-left">
        <p class="title">{{ productBase.title }}</p>
        <slot name="desc"></slot>
      </div>
      <div class="f-left product-itinerary-method">
        <div>
          <a-checkbox :checked="isNeedItinerary" @change="onNeedChange"> 需要报销凭证 </a-checkbox>
          <span class="product-itinerary-info">您当前航班{{ isFree ? '可享受' : '无' }}免费行程单邮寄，如需行程单请选择购买</span>
        </div>
        <div v-if="isNeedItinerary">
          <span>凭证类型：</span>
          <a-radio-group @change="onMethodChange" >
            <!-- <a-radio :value="0"> 不需要 </a-radio> -->
            <a-radio :value="1"> 需要快递 </a-radio>
            <a-radio :value="2"> {{ itineraryAddressConfig.buttonText ?? '机场及市区海航柜台自取' }}</a-radio>
          </a-radio-group>
        </div>
      </div>
      <div class="f-right extra">
        <span v-if="productCode">行程单 {{ amount }} 元</span>
      </div>
    </div>
    <div class="contact clearfix" v-if="isNeedItinerary">
      <template v-if="selectType === 1">
        <div class="des">
          <a-radio-group>
            <!-- 正常应该使用 offerItemId，但是部分舱位免费行程单是相同 offerItemId-->
            <a-radio v-for="product in products" @click="onProductChange" :key="product.services?.[0]?.productCode" :value="product.services?.[0]?.productCode"> {{ product.services?.[0]?.productName }} </a-radio>
          </a-radio-group>
        </div>
        <div class="clearfix form" v-if="productCode">
          <a-form layout="vertical">
            <a-form-item label="收件人" class="f-left input name">
              <a-input
                size="large"
                v-model="contact.name"
                placeholder="请输入收件人姓名"
                @blur="onChange"
              />
            </a-form-item>
            <a-form-item label="联系电话" class="f-left input phone">
              <a-input
                size="large"
                v-model="contact.phone"
                placeholder="请输入联系人电话号码"
                @blur="onChange"
              />
            </a-form-item>
            <div class="f-left clearfix address">
              <a-form-item label="收件地址" class="input">
                <a-input
                  size="large"
                  v-model="contact.address"
                  placeholder="请输入收件人地址"
                  @blur="onChange"
                />
              </a-form-item>
            </div>
          </a-form>
        </div>

      </template>
      <template v-else-if="selectType === 2">
        <!-- <div class="product-itinerary-tips" v-html="itineraryTips"> </div> -->
        <div class="product-itinerary-tips">
          <p v-html="ifInternational ? itineraryAddressConfig.internationalNotice : itineraryAddressConfig.notice" style="margin-bottom: 20px"></p>
          <div v-if="itineraryAddressConfig?.depData && Object.keys(itineraryAddressConfig.depData).length !== 0" style="margin-bottom: 20px">
            <p>{{ itineraryAddressConfig.depData.city }}营业部</p>
            <p>{{ itineraryAddressConfig.depData.office }}: {{ itineraryAddressConfig.depData.address }}</p>
          </div>
          <div v-if="itineraryAddressConfig?.arrData && Object.keys(itineraryAddressConfig.arrData).length !== 0">
            <p>{{ itineraryAddressConfig.arrData.city }}营业部</p>
            <p>{{ itineraryAddressConfig.arrData.office }}: {{ itineraryAddressConfig.arrData.address }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getNetFareAmount } from '@/assets/js/util'
import { get } from 'lodash'
import storage from '@/assets/js/storage'

export default {
  data () {
    return {
      contact: {
        name: '',
        phone: '',
        address: ''
      },
      isNeedItinerary: false,
      productCode: null,
      product: {},
      selectType: null,
      itineraryTips: '',
      itineraryAddressConfig: {}
    }
  },
  props: {
    type: {
      type: String,
      required: true,
      default: 'itinerary'
    },
    products: {
      type: Array,
      default: function () {
        return []
      }
    },
    productBase: [Object, Array],
    isFollow: {
      type: Boolean,
      default: true
    },
    ifInternational: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    amount () {
      const { product = {} } = this
      const fareDetails = product.services?.[0]?.fareDetails
      if (!fareDetails) {
        return ''
      }
      return getNetFareAmount(fareDetails)
    },
    isFree () {
      const { products = [] } = this
      let isFree = true
      products.forEach(product => {
        const fareDetails = product.services?.[0]?.fareDetails
        const amount = getNetFareAmount(fareDetails)
        if (amount !== 0) {
          isFree = false
        }
      })
      return isFree
    }
  },
  async created () {
    try {
      await this.getCmsData()
    } catch (error) {
      console.log('error >>>> ', error)
    }
  },
  methods: {
    async getCmsData () {
      const { isFollow } = this
      const pageCmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) ?? {}
      this.itineraryTips = get(pageCmsData, 'itinerary-tips.content') ?? ''
      this.itineraryAddressConfig = get(pageCmsData, 'itinerary-address-config') ?? {}
      let shoppingCart = {}
      let orgDst = {}
      let segment = {}
      if (!isFollow) {
        shoppingCart = storage.getItem(`extraItinerarys`) ?? {}
        if (typeof (shoppingCart) === 'string') {
          shoppingCart = JSON.parse(shoppingCart)
        }
        orgDst = shoppingCart.itinerarys?.[0]
        segment = { depCode: orgDst.depCode, arrCode: orgDst.arrCode }
      } else {
        shoppingCart = storage.getItem(`SHOPPINGCART_DATA`) ?? {}
        orgDst = shoppingCart.offers?.[0]?.detail?.itinerarys?.[0]?.orgDsts?.[0]
        segment = { depCode: orgDst.departureCode, arrCode: orgDst.arrivalCode }
      }
      const list = this.itineraryAddressConfig?.list ?? []
      this.itineraryAddressConfig.depData = list.find(item => item.code === segment.depCode) ?? {}
      this.itineraryAddressConfig.arrData = list.find(item => item.code === segment.arrCode) ?? {}
    },
    onChange () {
      this.updateItinerary()
    },
    onProductChange (e, value) {
      // 恢复
      this.productCode = null
      this.updateItinerary()
      // 赋值
      this.productCode = e.target.value
      this.product = this.products.find(product => { return product.services?.[0]?.productCode === this.productCode })
      this.updateItinerary()
    },
    onNeedChange (e) {
      this.isNeedItinerary = e.target.checked
      if (!this.isNeedItinerary) {
        this.productCode = null
      }
      this.updateItinerary()
    },
    onMethodChange (e) {
      this.selectType = e.target.value
      if (this.selectType !== 1) {
        this.productCode = null
      }
      this.updateItinerary()
    },
    updateItinerary () {
      const { contact, product, productCode } = this
      this.$emit(
        'change',
        {
          ...contact,
          invoice: productCode ? 'Y' : 'N'
        },
        product?.services?.[0] ?? {}
      )
    }
  }
}
</script>
<style lang="less" scoped>
  .product-itinerary-jd {
    .product-itinerary-method {
      margin-left: 30px;
      line-height: 30px;
      font-size: 13px;
    }
    .product-itinerary-info {
      color: @primary-color;
    }
    .product-itinerary-tips {
      padding: 20px 40px;
      font-size: 13px;
      line-height: 1.5;
      vertical-align: top;
    }
  }
</style>
